import classNames from 'classnames';
import { SocialIconsDetails } from './constants';
interface Props {
  className?: string;
}
function SocialIcons({
  className
}: Props) {
  return <div className={classNames(className, 'flex flex-col items-center gap-2 lg:gap-3')} data-sentry-component="SocialIcons" data-sentry-source-file="social-icons.tsx">
            <div className='flex w-full justify-center gap-3'>
                {SocialIconsDetails.map(({
        icon,
        name,
        url
      }) => <a key={name} aria-label={name} href={url} rel='noreferrer nofollow' target='_blank' className='group flex h-6 w-6 items-center justify-center'>
                        {icon}
                    </a>)}
            </div>
            <span className='text-sm leading-6 text-white'>ما را در شبکه‌های اجتماعی دنبال کنید!</span>
        </div>;
}
export default SocialIcons;